<script setup lang="ts">
import { onMounted }                                from "vue";
import Tabs                                         from 'flowbite/lib/esm/components/tabs';
import { findElem }                                 from "@TsUtils/helpers";
import type { TabItem, TabsInterface, TabsOptions } from "flowbite";
import type { TypeServicesData }                    from "@ViewPages/Main/Components/commonTypes";
import Container                                    from "@ViewCommonComponents/Container.vue";
import SectionTitle                                 from "@ViewCommonComponents/SectionTitle.vue";
import Section                                      from "@ViewCommonComponents/Section.vue";
import Card                                         from "@ViewCommonComponents/Card.vue";

defineProps<TypeServicesData>();

const buttonSwitchClasses = [
        'transition-color/bg duration-300 py-3.5 px-2.5'
    ].join(' '),
    activeClasses = 'text-custom-gray-100 bg-custom-green-600';

onMounted(() => {
    const tabsContainerEl = findElem('#service-tabs-list'),
        tabContentItems : TabItem[] = [
            {
                id: 'container',
                triggerEl: findElem('#container-transportation-tab') as HTMLElement,
                targetEl: findElem('#container-transportation-tab-content') as HTMLElement
            },
            {
                id: 'car',
                triggerEl: findElem('#car-transportation-tab') as HTMLElement,
                targetEl: findElem('#car-transportation-tab-content') as HTMLElement
            },
        ],
        options : TabsOptions = {
            activeClasses: activeClasses,
            inactiveClasses: 'test-inactive',
        };

    const tabs : TabsInterface = new Tabs(tabsContainerEl, tabContentItems, options);

    tabs.init();
});
</script>

<template>
    <Section classes="services" id="services">
        <Container>
            <div class="services__inner text-center">
                <SectionTitle classes="mb-25px lg:mb-9 xl:mb-45px"
                              v-html="__('services_title')"></SectionTitle>

                <div class="services__tabs inline-flex font-medium rounded-4xl border-2
                            border-custom-green-600 overflow-hidden mb-16"
                     id="service-tabs-list"
                     role="tablist">
                    <button type="button" :class="[buttonSwitchClasses]"
                            id="container-transportation-tab"
                            role="tab"
                            aria-controls="container-transportation-tab-content"
                            aria-selected="true">
                        {{ __('button_1') }}
                    </button>
                    <button type="button" :class="[buttonSwitchClasses]"
                            id="car-transportation-tab"
                            role="tab"
                            aria-controls="car-transportation-tab-content"
                            aria-selected="false">
                        {{ __('button_2') }}
                    </button>
                </div>

                <div class="services__tabs-content flex items-center gap-5">
                    <div class="grid max-xl:grid-cols-auto-fit-300px-1fr xl:grid-cols-3 grid-flow-row w-full
                                max-sm-5:place-items-center sm-5:justify-center
                                transition-all duration-300 gap-y-16 xl:gap-y-20 gap-x-7"
                         id="container-transportation-tab-content">

                        <Card v-for="data in services_data.containers" v-bind="data"></Card>
                    </div>

                    <div class="grid max-xl:grid-cols-auto-fit-300px-1fr xl:grid-cols-3 grid-flow-row w-full
                                max-sm-5:place-items-center sm-5:justify-center
                                transition-all duration-300 gap-y-16 xl:gap-y-20 gap-x-7"
                         id="car-transportation-tab-content">

                        <Card v-for="data in services_data.cars" v-bind="data"></Card>
                    </div>
                </div>
            </div>
        </Container>
    </Section>
</template>

<style scoped>

</style>
